<template lang="pug">
section
  h2.ad_text-primary.mb-3
    i Líderes asignados
  .card.ad_border1-secondary.rounded-xl.pt-3.pb-5.px-0
    .row.mx-0.my-2.d-flex.align-items-end
      .col-3
        h3.font-weight-bold.ad_text-secondary.mb-0
          | 
      .col-3.text-center.ml-auto
        span.ad_text-gray8.font-weight-bold.h5
          | Desafío semanal
      .col-3.text-center
        span.ad_text-gray8.font-weight-bold.h5
          | KPIs Adherencia
      .col-3.text-center
        span.ad_text-gray8.font-weight-bold.h5
          | Desarrollo personal
    div(v-for="(plan, index) in collabsPlans")
      .row.mx-0.my-2.d-flex.align-items-end 
        .col-3
          h3.font-weight-bold.ad_text-secondary.mb-0
            | {{plan.lider.name}}
          .col-12.p-0
            p.m-0
              strong KPI &nbsp;
              | {{plan.lider.kpi ? plan.lider.kpi.toFixed(2) : '--'}}% 
              strong.px-3 |
              strong ICA &nbsp;
              | {{plan.lider.ica ? plan.lider.ica : '--'}}%
        .col-3.text-center.ml-auto
          span.ml-2.num_circle.bg-primary.font-weight-bold
            | {{plan.weekly_challenge.length}}
        .col-3.text-center
          span.ml-2.num_circle.bg-primary.font-weight-bold
            | {{plan.kpicon.length}}
        .col-3.text-center
          span.ml-2.num_circle.bg-primary.font-weight-bold
            | {{plan.personal_development.length}}
      //- hr.mx-3(v-if="index != lideres.length - 1")
  
  h2.ad_text-primary.mt-5.mb-3
    i Desarrollo personal
  .card.ad_border1-secondary.rounded-xl.py-3.px-0
    .d-flex.flex-row.flex-wrap
      .col-12.col-xl-6.mb-3
        p.mb-2.ad_text-secondary.h5.font-weight-bold
          | Objetivos desarrollo personal (propios)
        .col-12.py-2.rounded-lg.ad_bg-gray
          table.w-100.text-center.table-rounded-body
            thead
              tr
                th
                th.w-50.text-left Objetivo
                th.w-30 Categoría
                th Activo
                th.w-5 Cumple
            tbody
              tr(v-for="(pdc, indexpdc) in personaldevelopments")
                td.align-top.py-2
                  div.align-items-start.pr-0
                    span.num_circle.ad_bg-secondary {{indexpdc + 1}}
                td.py-2.text-left
                  div.pl-2.align-items-start
                    | {{pdc.subcategory.name}}
                td.align-top.py-2
                  div.px-0
                    | {{pdc.category.name}}
                td.align-top.py-2
                  div.align-items-start
                    span.text-nowrap.ad_text-success
                      | {{pdc.date_limit | Week}} sem
                td.align-top.py-2
                  div.justify-content-center(v-if="pdc.accomplished")
                    i.icon-checkmark.ad_text-success.icon--1-5x
                  div.justify-content-center(v-if="!pdc.accomplished")
                    i.icon-cross.ad_text-danger.icon--1-5x

      .col-12.col-xl-6.mb-3
        p.mb-2.ad_text-secondary.h5.font-weight-bold
          | Desafíos de la semana
        .col-12.py-2.rounded-lg.ad_bg-gray
          table.w-100.text-center.table-rounded-body
            thead
              tr
                th
                th.w-50.text-left Desafío
                th Activo
                th.w-5 Cumple
            tbody
              tr(v-for="(wcc, indexwcc) in weeklychallengescon")
                td.align-top.py-2
                  div.align-items-start.pr-0
                    span.num_circle.ad_bg-secondary {{indexwcc + 1}}
                td.py-2.text-left
                  div.pl-2.align-items-start
                    | {{wcc.description}}
                td.align-top.py-2
                  div.align-items-start
                    span.text-nowrap.ad_text-success
                      | {{wcc.date | WeekDuration}} sem
                td.align-top.py-2
                  div.justify-content-center(v-if="wcc.accomplished")
                    i.icon-checkmark.ad_text-success.icon--1-5x
                  div.justify-content-center(v-if="!wcc.accomplished")
                    i.icon-cross.ad_text-danger.icon--1-5x

</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "ConsResumenExt",
  props: ["clickedNext", "currentStep"],
  components: {},
  data() {
    return {
      collabs: [],
      collabsPlans: [],
      personaldevelopments: [],
      weeklychallengescon: [],
      states: [],
      plan_con: null
    };
  },
  methods: {
    ...mapActions('plan_lider', [
      'collabsPlanWeekInfo', 'addComment', 'createIfDontExist', 'getCommentsByPLanId'
    ]),
    ...mapActions('kpicon', [
      'createKPIC', 'closeKpiCon', 'updateBKpiCon'
    ]),
    ...mapActions('personaldevelopment', [
      'createPDC', 'closePersonalDevelopment', 'updateBPersonalDevelopment'
    ]),
    ...mapActions('weeklychallenge', [
      'createWC', 'closeWeeklyChallenge', 'updateBWeeklyChallenge'
    ]),
    ...mapActions('State', [
      'statesList'
    ]),
    ...mapActions('weeklychallengecon', [
      'getWCClistByPlanConId', 'createWCC', 'updateBWeeklyChallengeCon'
    ]),
    ...mapActions('personaldevelopmentcon', [
      'getPDClistByPlanConId', 'createPDC', 'updateBPersonalDevelopmentCon'
    ]),
    ...mapActions('plan_con', [
      'addComment', 'getCommentsByPLanId'
    ]),
    ...mapActions('kpi', [
      'getKpiById'
    ]),
    ...mapActions('category', [
      'getCatById'
    ]),
    ...mapActions('subcategory', [
      'getSubcatById'
    ]),
    isStepActive(payload) {
      this.$emit('can-continue', {value: true})
    },
    getStates() {
      return new Promise((resolve, reject) => {
        const vm = this
        vm.statesList().then((response) => {
          vm.states = vm.$store.getters["State/getStates"]
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    getDetailsLiderPLans() {
      const vm = this
      return new Promise((res, rej) => {
        let getdetails = function (plan, index) {
          return new Promise((resolve, reject) => {
            vm.getPlanInfo(index).then((response) => {
              resolve()
            }, (error) => {
              reject(error)
            })
          })
        }
        let actionsPerPlan = vm.collabsPlans.map(getdetails)
        let results = Promise.all(actionsPerPlan)
        results.then(() => {
          res()
        }, (error) => {
          rej(error)
        })
      })      
    },
    getPlanInfo(index) {      
      return new Promise((resolve, reject) => {
        const vm = this
        vm.getsKpisPerPlan(index).then((response) => {
          vm.getsCatPdPerPlan(index).then((resp) => {
            vm.getsSubcatPdPerPlan(index).then((res) => {
              vm.getStatesPerWc(index).then((r) => {
                resolve()
              }, (ee) => {
                reject(ee)
              })              
            }, (e) => {
              reject(e)
            })
          }, (err) => {
            reject(err)
          })
          // resolve()
        }, (error) => {
          reject(error)          
        })
      })
    },
    getsKpisPerPlan(index) {
      return new Promise((res, rej) => {
        const vm = this
        let findingKpi = function(kpicon, indexk) {          
          return new Promise((resolve, reject) => {
            vm.getKpiById(kpicon.kpi).then((kpi) => {
              vm.collabsPlans[index].kpicon[indexk].kpi = kpi
              for (let s of vm.states) {                
                if (vm.collabsPlans[index].kpicon[indexk].state == s._id.toString()) {
                  vm.collabsPlans[index].kpicon[indexk].state = s
                }
              }
              resolve()
            }, (error) => {
              console.info(error)
              reject(error)
            })
          })
        }

        let actionsk = vm.collabsPlans[index].kpicon.map(findingKpi)
        let results = Promise.all(actionsk)
        results.then(() => {
          res()
        }, (err) => {
          rej(err)
        })
      })      
    },
    getsSubcatPdPerPlan(index) {
      return new Promise((res, rej) => {
        const vm = this
        let findingSubcat = function(pd, indexw) {
          return new Promise((resolve, reject) => {
            vm.getSubcatById(pd.subcategory).then((subcategory) => {
              vm.collabsPlans[index].personal_development[indexw].subcategory = subcategory
              resolve()
            }, (error) => {
              console.info(error)
              reject(error)
            })
          })
        }

        let actionsS = vm.collabsPlans[index].personal_development.map(findingSubcat)
        let results = Promise.all(actionsS)
        results.then(() => {
          res()
        }, (err) => {
          rej(err)
        })
      })      
    },
    getsCatPdPerPlan(index) {
      return new Promise((res, rej) => {
        const vm = this
        let findingCat = function(pd, indexw) {          
          return new Promise((resolve, reject) => {
            vm.getCatById(pd.category).then((category) => {
              vm.collabsPlans[index].personal_development[indexw].category = category 
              for (let s of vm.states) {
                if (vm.collabsPlans[index].personal_development[indexw].state == s._id) {
                  vm.collabsPlans[index].personal_development[indexw].state = s
                }
              }
              resolve()
            }, (error) => {
              console.info(error)
              reject(error)
            })
          })
        }

        let actionsC = vm.collabsPlans[index].personal_development.map(findingCat)
        let results = Promise.all(actionsC)
        results.then(() => {
          res()
        }, (err) => {
          rej(err)
        })
      })      
    },
    getStatesPerWc(index) {
      return new Promise((resolve, reject) => {
        const vm = this
        try {
          for (let indexwc in vm.collabsPlans[index].weekly_challenge) {
            for (let s of vm.states) {
              if (vm.collabsPlans[index].weekly_challenge[indexwc].state == s._id) {
                vm.collabsPlans[index].weekly_challenge[indexwc].state = s
              }
            }
          }
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    getWCCList() {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.getWCClistByPlanConId({plan: vm.plan_con._id}).then((response) => {
          vm.weeklychallengescon = vm.$store.getters['weeklychallengecon/getWeeklyChallengescon']
          resolve()
        }, (error) => {
          reject(error)
        })
      })  
    },
    getPersonaleDevConlist() {
      const vm = this
      return new Promise((resolve, reject) => {
        vm.getPDClistByPlanConId({plan: vm.plan_con._id}).then(() => {
          vm.personaldevelopments = vm.$store.getters['personaldevelopmentcon/getPersonalDevelopments']
          resolve()
        }, (error) => {
          reject(error)
        })
      })      
    }
  },
  mounted () {
    const vm = this;
    const { id } = vm.$store.state.auth.user
    const loading = vm.$toast.loading('Cargando...')
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.plan_con = vm.$store.getters['plan_con/getPlan']
    //check for finish plan notification
    vm.$root.$on('hidePlanificationCon', hide => {
      if (hide) {
        vm.$emit('completed-step', {value: false});
        m.$emit("can-continue", { value: false});
      }
    })
    if (vm.user.profile.name != 'Consultor') {
      vm.$router.replace({ path: '/permission' })
    } else {
      vm.createIfDontExist(vm.user.id).then(response => {
        vm.collabs = vm.$store.getters['plan_lider/getCollabs']      
        vm.collabsPlanWeekInfo({collabs: vm.collabs}).then(response => {
          vm.collabsPlans = vm.$store.getters['plan_lider/getCollabsPlan']
          vm.getStates().then(() => {
            vm.getDetailsLiderPLans().then(() => {
              vm.getWCCList().then(() => {
                vm.getPersonaleDevConlist().then(() => {
                  if (vm.plan_con.state.order == 0) {
                    vm.$emit('completed-step', {value: true});
                    vm.$emit("can-continue", { value: true });
                  }
                  loading.hide()
                }, (e) => {
                  loading.hide()
                  vm.$notify({
                    type: 'danger',
                    title: 'Notificación',
                    content: e,
                    closeable: true,
                    duration: 5000
                  })
                })
              }, (error) => {
                loading.hide()
                vm.$notify({
                  type: 'danger',
                  title: 'Notificación',
                  content: error,
                  closeable: true,
                  duration: 5000
                })
              })
            }, (err) => {
              loading.hide()
              vm.$notify({
                type: 'danger',
                title: 'Notificación',
                content: err,
                closeable: true,
                duration: 5000
              })
            })
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            })
          })
        }, (error) => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/ps-consultor-externo-resumen.vue